<template>
    <div style="border-top: 1px solid #555; margin-top: 0px; padding: 14px 16px 0 16px; display: flex;">
        <div v-if="!isGeoRestricted && !isNewUser" @click="$router.push('/brightplans');">
            <img width="800" height="800" :src="src" style="box-shadow: 0 0 10px rgb(0 0 0 / 20%); max-width: 100%; height: auto; margin: 0; padding: 0; border-radius: 10px;">
        </div>
    </div>
</template>

<script>
import { getFirstRunTimeStamp } from "@/utils/user/first-run-timestamp";

export default {
    computed: {
        isGeoRestricted() {
            try {
                const restricted = ["Indian/", "Asia/Colombo", "Asia/Calcutta", "Asia/Karachi"];
                const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (restricted.find(r => tz.includes(r))) return true;
                return false;
            } catch (e) {
                return false;
            }
        },
        isNewUser() {
            const firstRunTS =  getFirstRunTimeStamp();
            let diff = Date.now() - parseInt(firstRunTS);
            diff = Math.floor(diff/1000);
            return diff < 60;
        },
        src() {
            const srcs = [
                "/images/bp-banner-2024.jpg",
                //"/images/bp001.jpg",
                //"/images/bp002.jpg",
                // "/images/bp003.jpg",
                //"/images/bp004.jpg",
                //"/images/bp005.jpg",
                //"/images/bp006.jpg",
                //"/images/bp007.jpg",
                //"/images/bp008.jpg",
                //"/images/bp009.jpg",
                //"/images/bp010.jpg",
                //"/images/bp011.jpg",
                //"/images/bp012.jpg",
                //"/images/bp013.jpg",
                //"/images/bp014.jpg",
            ];
            return srcs[Math.floor(Math.random()*srcs.length)];
        }
    }
}
</script>
